/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as ConnectCallbackRouteImport } from './routes/connect.callback'
import { Route as DevLoginRouteImport } from './routes/dev.login'
import { Route as TestIndexRouteImport } from './routes/test.index'
import { Route as TestCrashRouteImport } from './routes/test.crash'
import { Route as TestEmailsRouteImport } from './routes/test.emails'
import { Route as AuthedAccountIndexRouteImport } from './routes/_authed.account.index'
import { Route as AuthedAccountProfileRouteImport } from './routes/_authed.account.profile'
import { Route as AuthedAccountSecurityRouteImport } from './routes/_authed.account.security'
import { Route as AuthedAccountSubscriptionRouteImport } from './routes/_authed.account.subscription'
import { Route as AuthedAccountTermsRouteImport } from './routes/_authed.account.terms'
import { Route as AuthedTeamsTeamIdProjectsIndexRouteImport } from './routes/_authed.teams.$teamId.projects.index'
import { Route as AuthedTeamsTeamIdProjectsProjectIdIndexRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.index'
import { Route as AuthedTeamsTeamIdProjectsProjectIdMemoryRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.memory'
import { Route as AuthedTeamsTeamIdProjectsProjectIdN2000RouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.n2000'
import { Route as AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.pond-bat-checker'
import { Route as AuthedTeamsTeamIdProjectsProjectIdProjectAreaRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.project-area'
import { Route as AuthedTeamsTeamIdProjectsProjectIdProvincialRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.provincial'
import { Route as AuthedTeamsTeamIdProjectsProjectIdReportWriterRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.report-writer'
import { Route as AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRouteImport } from './routes/_authed.teams.$teamId.projects.$projectId.species-checker'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DevLoginRoute = DevLoginRouteImport.update({
  id: '/dev/login',
  path: '/dev/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TestIndexRoute = TestIndexRouteImport.update({
  id: '/test/',
  path: '/test/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestCrashRoute = TestCrashRouteImport.update({
  id: '/test/crash',
  path: '/test/crash',
  getParentRoute: () => rootRouteImport,
} as any)
const TestEmailsRoute = TestEmailsRouteImport.update({
  id: '/test/emails',
  path: '/test/emails',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAccountIndexRoute = AuthedAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountProfileRoute = AuthedAccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountSecurityRoute = AuthedAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountSubscriptionRoute =
  AuthedAccountSubscriptionRouteImport.update({
    id: '/account/subscription',
    path: '/account/subscription',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAccountTermsRoute = AuthedAccountTermsRouteImport.update({
  id: '/account/terms',
  path: '/account/terms',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamsTeamIdProjectsIndexRoute =
  AuthedTeamsTeamIdProjectsIndexRouteImport.update({
    id: '/teams/$teamId/projects/',
    path: '/teams/$teamId/projects/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdIndexRoute =
  AuthedTeamsTeamIdProjectsProjectIdIndexRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/',
    path: '/teams/$teamId/projects/$projectId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdMemoryRoute =
  AuthedTeamsTeamIdProjectsProjectIdMemoryRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/memory',
    path: '/teams/$teamId/projects/$projectId/memory',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdN2000Route =
  AuthedTeamsTeamIdProjectsProjectIdN2000RouteImport.update({
    id: '/teams/$teamId/projects/$projectId/n2000',
    path: '/teams/$teamId/projects/$projectId/n2000',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute =
  AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/pond-bat-checker',
    path: '/teams/$teamId/projects/$projectId/pond-bat-checker',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute =
  AuthedTeamsTeamIdProjectsProjectIdProjectAreaRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/project-area',
    path: '/teams/$teamId/projects/$projectId/project-area',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdProvincialRoute =
  AuthedTeamsTeamIdProjectsProjectIdProvincialRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/provincial',
    path: '/teams/$teamId/projects/$projectId/provincial',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute =
  AuthedTeamsTeamIdProjectsProjectIdReportWriterRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/report-writer',
    path: '/teams/$teamId/projects/$projectId/report-writer',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute =
  AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRouteImport.update({
    id: '/teams/$teamId/projects/$projectId/species-checker',
    path: '/teams/$teamId/projects/$projectId/species-checker',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AuthedIndexRoute
  '/cookies': typeof CookiesRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/dev/login': typeof DevLoginRoute
  '/test/crash': typeof TestCrashRoute
  '/test/emails': typeof TestEmailsRoute
  '/test/': typeof TestIndexRoute
  '/account/profile': typeof AuthedAccountProfileRoute
  '/account/security': typeof AuthedAccountSecurityRoute
  '/account/subscription': typeof AuthedAccountSubscriptionRoute
  '/account/terms': typeof AuthedAccountTermsRoute
  '/account/': typeof AuthedAccountIndexRoute
  '/teams/$teamId/projects/': typeof AuthedTeamsTeamIdProjectsIndexRoute
  '/teams/$teamId/projects/$projectId/memory': typeof AuthedTeamsTeamIdProjectsProjectIdMemoryRoute
  '/teams/$teamId/projects/$projectId/n2000': typeof AuthedTeamsTeamIdProjectsProjectIdN2000Route
  '/teams/$teamId/projects/$projectId/pond-bat-checker': typeof AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute
  '/teams/$teamId/projects/$projectId/project-area': typeof AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute
  '/teams/$teamId/projects/$projectId/provincial': typeof AuthedTeamsTeamIdProjectsProjectIdProvincialRoute
  '/teams/$teamId/projects/$projectId/report-writer': typeof AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute
  '/teams/$teamId/projects/$projectId/species-checker': typeof AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute
  '/teams/$teamId/projects/$projectId/': typeof AuthedTeamsTeamIdProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/cookies': typeof CookiesRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/dev/login': typeof DevLoginRoute
  '/test/crash': typeof TestCrashRoute
  '/test/emails': typeof TestEmailsRoute
  '/': typeof AuthedIndexRoute
  '/test': typeof TestIndexRoute
  '/account/profile': typeof AuthedAccountProfileRoute
  '/account/security': typeof AuthedAccountSecurityRoute
  '/account/subscription': typeof AuthedAccountSubscriptionRoute
  '/account/terms': typeof AuthedAccountTermsRoute
  '/account': typeof AuthedAccountIndexRoute
  '/teams/$teamId/projects': typeof AuthedTeamsTeamIdProjectsIndexRoute
  '/teams/$teamId/projects/$projectId/memory': typeof AuthedTeamsTeamIdProjectsProjectIdMemoryRoute
  '/teams/$teamId/projects/$projectId/n2000': typeof AuthedTeamsTeamIdProjectsProjectIdN2000Route
  '/teams/$teamId/projects/$projectId/pond-bat-checker': typeof AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute
  '/teams/$teamId/projects/$projectId/project-area': typeof AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute
  '/teams/$teamId/projects/$projectId/provincial': typeof AuthedTeamsTeamIdProjectsProjectIdProvincialRoute
  '/teams/$teamId/projects/$projectId/report-writer': typeof AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute
  '/teams/$teamId/projects/$projectId/species-checker': typeof AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute
  '/teams/$teamId/projects/$projectId': typeof AuthedTeamsTeamIdProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/cookies': typeof CookiesRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/dev/login': typeof DevLoginRoute
  '/test/crash': typeof TestCrashRoute
  '/test/emails': typeof TestEmailsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/test/': typeof TestIndexRoute
  '/_authed/account/profile': typeof AuthedAccountProfileRoute
  '/_authed/account/security': typeof AuthedAccountSecurityRoute
  '/_authed/account/subscription': typeof AuthedAccountSubscriptionRoute
  '/_authed/account/terms': typeof AuthedAccountTermsRoute
  '/_authed/account/': typeof AuthedAccountIndexRoute
  '/_authed/teams/$teamId/projects/': typeof AuthedTeamsTeamIdProjectsIndexRoute
  '/_authed/teams/$teamId/projects/$projectId/memory': typeof AuthedTeamsTeamIdProjectsProjectIdMemoryRoute
  '/_authed/teams/$teamId/projects/$projectId/n2000': typeof AuthedTeamsTeamIdProjectsProjectIdN2000Route
  '/_authed/teams/$teamId/projects/$projectId/pond-bat-checker': typeof AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute
  '/_authed/teams/$teamId/projects/$projectId/project-area': typeof AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute
  '/_authed/teams/$teamId/projects/$projectId/provincial': typeof AuthedTeamsTeamIdProjectsProjectIdProvincialRoute
  '/_authed/teams/$teamId/projects/$projectId/report-writer': typeof AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute
  '/_authed/teams/$teamId/projects/$projectId/species-checker': typeof AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute
  '/_authed/teams/$teamId/projects/$projectId/': typeof AuthedTeamsTeamIdProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/cookies'
    | '/login'
    | '/signed-out'
    | '/auth/callback'
    | '/connect/callback'
    | '/dev/login'
    | '/test/crash'
    | '/test/emails'
    | '/test/'
    | '/account/profile'
    | '/account/security'
    | '/account/subscription'
    | '/account/terms'
    | '/account/'
    | '/teams/$teamId/projects/'
    | '/teams/$teamId/projects/$projectId/memory'
    | '/teams/$teamId/projects/$projectId/n2000'
    | '/teams/$teamId/projects/$projectId/pond-bat-checker'
    | '/teams/$teamId/projects/$projectId/project-area'
    | '/teams/$teamId/projects/$projectId/provincial'
    | '/teams/$teamId/projects/$projectId/report-writer'
    | '/teams/$teamId/projects/$projectId/species-checker'
    | '/teams/$teamId/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/cookies'
    | '/login'
    | '/signed-out'
    | '/auth/callback'
    | '/connect/callback'
    | '/dev/login'
    | '/test/crash'
    | '/test/emails'
    | '/'
    | '/test'
    | '/account/profile'
    | '/account/security'
    | '/account/subscription'
    | '/account/terms'
    | '/account'
    | '/teams/$teamId/projects'
    | '/teams/$teamId/projects/$projectId/memory'
    | '/teams/$teamId/projects/$projectId/n2000'
    | '/teams/$teamId/projects/$projectId/pond-bat-checker'
    | '/teams/$teamId/projects/$projectId/project-area'
    | '/teams/$teamId/projects/$projectId/provincial'
    | '/teams/$teamId/projects/$projectId/report-writer'
    | '/teams/$teamId/projects/$projectId/species-checker'
    | '/teams/$teamId/projects/$projectId'
  id:
    | '__root__'
    | '/$'
    | '/_authed'
    | '/cookies'
    | '/login'
    | '/signed-out'
    | '/auth/callback'
    | '/connect/callback'
    | '/dev/login'
    | '/test/crash'
    | '/test/emails'
    | '/_authed/'
    | '/test/'
    | '/_authed/account/profile'
    | '/_authed/account/security'
    | '/_authed/account/subscription'
    | '/_authed/account/terms'
    | '/_authed/account/'
    | '/_authed/teams/$teamId/projects/'
    | '/_authed/teams/$teamId/projects/$projectId/memory'
    | '/_authed/teams/$teamId/projects/$projectId/n2000'
    | '/_authed/teams/$teamId/projects/$projectId/pond-bat-checker'
    | '/_authed/teams/$teamId/projects/$projectId/project-area'
    | '/_authed/teams/$teamId/projects/$projectId/provincial'
    | '/_authed/teams/$teamId/projects/$projectId/report-writer'
    | '/_authed/teams/$teamId/projects/$projectId/species-checker'
    | '/_authed/teams/$teamId/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  CookiesRoute: typeof CookiesRoute
  LoginRoute: typeof LoginRoute
  SignedOutRoute: typeof SignedOutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  DevLoginRoute: typeof DevLoginRoute
  TestCrashRoute: typeof TestCrashRoute
  TestEmailsRoute: typeof TestEmailsRoute
  TestIndexRoute: typeof TestIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/callback': {
      id: '/connect/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/login': {
      id: '/dev/login'
      path: '/dev/login'
      fullPath: '/dev/login'
      preLoaderRoute: typeof DevLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/': {
      id: '/test/'
      path: '/test'
      fullPath: '/test/'
      preLoaderRoute: typeof TestIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/crash': {
      id: '/test/crash'
      path: '/test/crash'
      fullPath: '/test/crash'
      preLoaderRoute: typeof TestCrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/emails': {
      id: '/test/emails'
      path: '/test/emails'
      fullPath: '/test/emails'
      preLoaderRoute: typeof TestEmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/account/': {
      id: '/_authed/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthedAccountIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/profile': {
      id: '/_authed/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthedAccountProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/security': {
      id: '/_authed/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AuthedAccountSecurityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/subscription': {
      id: '/_authed/account/subscription'
      path: '/account/subscription'
      fullPath: '/account/subscription'
      preLoaderRoute: typeof AuthedAccountSubscriptionRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/terms': {
      id: '/_authed/account/terms'
      path: '/account/terms'
      fullPath: '/account/terms'
      preLoaderRoute: typeof AuthedAccountTermsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/': {
      id: '/_authed/teams/$teamId/projects/'
      path: '/teams/$teamId/projects'
      fullPath: '/teams/$teamId/projects/'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/': {
      id: '/_authed/teams/$teamId/projects/$projectId/'
      path: '/teams/$teamId/projects/$projectId'
      fullPath: '/teams/$teamId/projects/$projectId/'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/memory': {
      id: '/_authed/teams/$teamId/projects/$projectId/memory'
      path: '/teams/$teamId/projects/$projectId/memory'
      fullPath: '/teams/$teamId/projects/$projectId/memory'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdMemoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/n2000': {
      id: '/_authed/teams/$teamId/projects/$projectId/n2000'
      path: '/teams/$teamId/projects/$projectId/n2000'
      fullPath: '/teams/$teamId/projects/$projectId/n2000'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdN2000RouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/pond-bat-checker': {
      id: '/_authed/teams/$teamId/projects/$projectId/pond-bat-checker'
      path: '/teams/$teamId/projects/$projectId/pond-bat-checker'
      fullPath: '/teams/$teamId/projects/$projectId/pond-bat-checker'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/project-area': {
      id: '/_authed/teams/$teamId/projects/$projectId/project-area'
      path: '/teams/$teamId/projects/$projectId/project-area'
      fullPath: '/teams/$teamId/projects/$projectId/project-area'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdProjectAreaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/provincial': {
      id: '/_authed/teams/$teamId/projects/$projectId/provincial'
      path: '/teams/$teamId/projects/$projectId/provincial'
      fullPath: '/teams/$teamId/projects/$projectId/provincial'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdProvincialRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/report-writer': {
      id: '/_authed/teams/$teamId/projects/$projectId/report-writer'
      path: '/teams/$teamId/projects/$projectId/report-writer'
      fullPath: '/teams/$teamId/projects/$projectId/report-writer'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdReportWriterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/projects/$projectId/species-checker': {
      id: '/_authed/teams/$teamId/projects/$projectId/species-checker'
      path: '/teams/$teamId/projects/$projectId/species-checker'
      fullPath: '/teams/$teamId/projects/$projectId/species-checker'
      preLoaderRoute: typeof AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAccountProfileRoute: typeof AuthedAccountProfileRoute
  AuthedAccountSecurityRoute: typeof AuthedAccountSecurityRoute
  AuthedAccountSubscriptionRoute: typeof AuthedAccountSubscriptionRoute
  AuthedAccountTermsRoute: typeof AuthedAccountTermsRoute
  AuthedAccountIndexRoute: typeof AuthedAccountIndexRoute
  AuthedTeamsTeamIdProjectsIndexRoute: typeof AuthedTeamsTeamIdProjectsIndexRoute
  AuthedTeamsTeamIdProjectsProjectIdMemoryRoute: typeof AuthedTeamsTeamIdProjectsProjectIdMemoryRoute
  AuthedTeamsTeamIdProjectsProjectIdN2000Route: typeof AuthedTeamsTeamIdProjectsProjectIdN2000Route
  AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute: typeof AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute
  AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute: typeof AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute
  AuthedTeamsTeamIdProjectsProjectIdProvincialRoute: typeof AuthedTeamsTeamIdProjectsProjectIdProvincialRoute
  AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute: typeof AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute
  AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute: typeof AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute
  AuthedTeamsTeamIdProjectsProjectIdIndexRoute: typeof AuthedTeamsTeamIdProjectsProjectIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAccountProfileRoute: AuthedAccountProfileRoute,
  AuthedAccountSecurityRoute: AuthedAccountSecurityRoute,
  AuthedAccountSubscriptionRoute: AuthedAccountSubscriptionRoute,
  AuthedAccountTermsRoute: AuthedAccountTermsRoute,
  AuthedAccountIndexRoute: AuthedAccountIndexRoute,
  AuthedTeamsTeamIdProjectsIndexRoute: AuthedTeamsTeamIdProjectsIndexRoute,
  AuthedTeamsTeamIdProjectsProjectIdMemoryRoute:
    AuthedTeamsTeamIdProjectsProjectIdMemoryRoute,
  AuthedTeamsTeamIdProjectsProjectIdN2000Route:
    AuthedTeamsTeamIdProjectsProjectIdN2000Route,
  AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute:
    AuthedTeamsTeamIdProjectsProjectIdPondBatCheckerRoute,
  AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute:
    AuthedTeamsTeamIdProjectsProjectIdProjectAreaRoute,
  AuthedTeamsTeamIdProjectsProjectIdProvincialRoute:
    AuthedTeamsTeamIdProjectsProjectIdProvincialRoute,
  AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute:
    AuthedTeamsTeamIdProjectsProjectIdReportWriterRoute,
  AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute:
    AuthedTeamsTeamIdProjectsProjectIdSpeciesCheckerRoute,
  AuthedTeamsTeamIdProjectsProjectIdIndexRoute:
    AuthedTeamsTeamIdProjectsProjectIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthedRoute: AuthedRouteWithChildren,
  CookiesRoute: CookiesRoute,
  LoginRoute: LoginRoute,
  SignedOutRoute: SignedOutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  ConnectCallbackRoute: ConnectCallbackRoute,
  DevLoginRoute: DevLoginRoute,
  TestCrashRoute: TestCrashRoute,
  TestEmailsRoute: TestEmailsRoute,
  TestIndexRoute: TestIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
